import { useQuery, useQueryClient } from '@tanstack/react-query';

import { getReferralCode } from '@arrived/api_v2';
import { ReferralCode } from '@arrived/models';

import { MAX_STALE_TIME, UseQueryOptions } from '../queries.utils';
import { referralsQueryKey, referralsQueryKeyFn } from './referrals.keys';

export function useGetReferralCodeQuery(options?: UseQueryOptions<ReferralCode>) {
  const queryClient = useQueryClient();

  return useQuery(referralsQueryKey, async () => getReferralCode(), {
    ...options,
    onSuccess: (data) => {
      queryClient.setQueryData(referralsQueryKeyFn(data), data);

      options?.onSuccess?.(data);
    },
    staleTime: options?.staleTime ?? MAX_STALE_TIME,
  });
}
